"use strict";
var moment = require("moment");
var constants_1 = require("./constants");
function returnDateValidator(departureDateControl, maxDate, minDate, overrideValidation) {
    if (maxDate === void 0) { maxDate = null; }
    if (minDate === void 0) { minDate = null; }
    if (overrideValidation === void 0) { overrideValidation = false; }
    return function (control) {
        // return date must be a valid date
        var value = control.value;
        if (value && value !== '') {
            var dateValue = moment(value, constants_1.Constants.DATE_PARSE_FORMAT);
            if (!dateValue.isValid()) {
                return { 'invalid': value };
            }
            // return date must be on or after departure date
            if (departureDateControl && departureDateControl.valid) {
                var departureValue = moment(departureDateControl.value, constants_1.Constants.DATE_PARSE_FORMAT);
                if (dateValue.startOf('day').isBefore(departureValue.startOf('day'))) {
                    return { 'beforeDeparture': value };
                }
            }
            // return date must be on or before max date
            if (maxDate) {
                var maxValue = moment(maxDate, constants_1.Constants.DATE_PARSE_FORMAT);
                if (maxValue.isValid() && dateValue.startOf('day').isAfter(maxValue.startOf('day'))) {
                    return { 'afterMax': value };
                }
            }
            if (minDate) {
                var minValue = moment(minDate, constants_1.Constants.DATE_PARSE_FORMAT);
                if (minValue.isValid() && dateValue.startOf('day').isBefore(minValue.startOf('day'))) {
                    return { 'beforeMin': value };
                }
            }
            if (!overrideValidation) {
                // return date must be after today
                if (dateValue.startOf('day').isBefore(moment().startOf('day'))) {
                    return { 'beforeToday': value };
                }
            }
        }
        return null;
    };
}
exports.returnDateValidator = returnDateValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/return-date.validator.js